import { Link } from "react-router-dom";
import { Icon, Image } from "semantic-ui-react"
import logo from '../assets/authorator_logo_no-dot.png';
export function AuthStdFooter() {
  return (
    <><div className="footer">
      <Image className="footerSiteLogo" src={logo} size="mini" />
      <span className="footerCopyRight" >© 2023 Authorator-ai LLC</span>
      <div className="footerSocialContainer">
        <Link to="/" > <Icon className="footerSocialLinks" name="facebook f" size="big" color="grey" /></Link>
        <Link to="/" > <Icon className="footerSocialLinks" name="twitter" size="big" color="grey" /></Link>
        <Link to="/" > <Icon className="footerSocialLinks" name="instagram" size="big" color="grey" /></Link>
      </div>
    </div >
    </>
  )
}